var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBannerPlaceholder = function SvgBannerPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#banner-placeholder_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6.716,
    width: 233,
    height: 132.569,
    rx: 8.034,
    fill: "url(#banner-placeholder_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.499,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.209 99.122h63.272c.358 0 .707-.039 1.043-.112.335.073.684.112 1.042.112h36.156a4.867 4.867 0 1 0 0-9.734h-4.172a4.867 4.867 0 1 1 0-9.735h13.21a4.867 4.867 0 1 0 0-9.734h-15.296a4.867 4.867 0 1 0 0-9.734h-44.499a4.867 4.867 0 0 0 0-9.734H93.334a4.867 4.867 0 1 0 0 9.734H65.522a4.867 4.867 0 1 0 0 9.734h17.382a4.867 4.867 0 0 1 0 9.734H55.093a4.867 4.867 0 0 0 0 9.734h27.116a4.867 4.867 0 0 0 0 9.735Zm113.334 0a4.867 4.867 0 1 0 0-9.734 4.867 4.867 0 0 0 0 9.734Z",
    fill: "#EAE6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m98.4 102.683-2.83.397a2.781 2.781 0 0 1-3.141-2.367l-7.741-55.082a2.781 2.781 0 0 1 2.367-3.14l54.393-7.645a2.78 2.78 0 0 1 3.141 2.367l.666 4.733",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m100.156 99.616-2.57.365a2.516 2.516 0 0 1-2.848-2.145l-6.95-50.009a2.535 2.535 0 0 1 2.153-2.856l49.392-7.02a2.515 2.515 0 0 1 2.848 2.145l.598 4.298 6.4 46.305c.213 1.538-.848 2.96-2.369 3.175a2.739 2.739 0 0 1-.049.006l-46.605 5.736Z",
    fill: "#EAE6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.4 102.683-2.83.397a2.781 2.781 0 0 1-3.141-2.367l-7.741-55.082a2.781 2.781 0 0 1 2.367-3.14l54.393-7.645a2.78 2.78 0 0 1 3.141 2.367l.666 4.733",
    stroke: "#E1DDDB",
    strokeWidth: 1.738,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.834 45.152.348 2.17",
    stroke: "#D7D3D1",
    strokeWidth: 1.738,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.81 48.01a1.912 1.912 0 0 1 2.101-1.703l54.628 5.742a1.911 1.911 0 0 1 1.701 2.101l-5.814 55.319a1.912 1.912 0 0 1-2.101 1.702l-54.628-5.742a1.91 1.91 0 0 1-1.701-2.101l5.814-55.319Z",
    fill: "#fff",
    stroke: "#E1DDDB",
    strokeWidth: 1.738
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.59 54.104a2.085 2.085 0 0 1 2.292-1.857l43.563 4.579a2.086 2.086 0 0 1 1.857 2.292l-3.852 36.65a2.086 2.086 0 0 1-2.292 1.856l-43.564-4.58a2.085 2.085 0 0 1-1.856-2.292l3.852-36.648Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m114.709 82.35 6.812-4.595a2.781 2.781 0 0 1 3.593.413l4.988 5.37a.695.695 0 0 0 .947.067l10.666-8.642a2.78 2.78 0 0 1 4.086.65l6.94 10.734.996 1.663-.477 5.65a.696.696 0 0 1-.77.632l-39.605-4.4a.695.695 0 0 1-.616-.755l.525-5.7 1.915-1.087Z",
    fill: "#EAE6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.454 54.195a1.217 1.217 0 0 1 1.337-1.083l43.564 4.578c.668.07 1.153.67 1.083 1.338l-3.852 36.648a1.218 1.218 0 0 1-1.338 1.083l-43.563-4.579a1.217 1.217 0 0 1-1.083-1.337l3.852-36.648Z",
    stroke: "#E1DDDB",
    strokeWidth: 1.738
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.252,
    cy: 65.712,
    r: 4.172,
    transform: "rotate(6 123.252 65.712)",
    fill: "#EAE6E5",
    stroke: "#E1DDDB",
    strokeWidth: 1.738
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.309 83.425 8.21-5.67a2.781 2.781 0 0 1 3.593.413l4.988 5.37a.695.695 0 0 0 .947.066l10.666-8.642a2.782 2.782 0 0 1 4.086.65l7.693 12.207",
    stroke: "#E1DDDB",
    strokeWidth: 1.738,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-placeholder_svg__b",
    x1: 242,
    y1: 73,
    x2: 9,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "banner-placeholder_svg__a",
    x: 0.966,
    y: 0.69,
    width: 249.069,
    height: 148.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.009
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.017
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47402_208429"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.009
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.009
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_47402_208429",
    result: "effect2_dropShadow_47402_208429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_47402_208429",
    result: "shape"
  })))));
};
export { SvgBannerPlaceholder as ReactComponent };
export default __webpack_public_path__ + "09073099583276069205cff10570d91d.svg";